import { useSyncExternalStore } from 'react';
import { getNetworkQuality, subscribeNetworkQuality } from '@/services/networkQuality';

export const useNetworkStatus = () =>
    useSyncExternalStore(subscribeNetworkQuality, getNetworkQuality, () => 'GOOD' as const);
